import { render, staticRenderFns } from "./cambioPwd.vue?vue&type=template&id=cf1fe51c&"
import script from "./cambioPwd.vue?vue&type=script&lang=js&"
export * from "./cambioPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports